import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Icon from "@/components/Icon";
import AdminLayout from "@/components/AdminLayout";

const TEXT_FIELDS = [
  ["brand_name", "Brand name"], ["short_name", "Short name"], ["tagline", "Tagline"],
  ["support_email", "Support email"], ["company_address", "Company address"],
  ["copyright", "Copyright text"], ["watermark_text", "QR watermark text"],
];
const URL_FIELDS = [["logo_light", "Logo (light)"], ["logo_dark", "Logo (dark)"], ["favicon", "Favicon"], ["og_image", "Social share image"], ["watermark_logo", "Watermark logo"]];

export default function AdminBranding() {
  const [b, setB] = useState(null);
  const [isOwner, setIsOwner] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/branding").then(({ data }) => setB(data.branding)).catch(() => {});
    api.get("/admin/me").then(({ data }) => setIsOwner(data.platform_role === "owner")).catch(() => {});
  }, []);
  const set = (k, v) => setB({ ...b, [k]: v });
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/branding", { branding: b }); setB(data.branding); toast.success("Branding saved & published"); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <AdminLayout title="Branding & Appearance" subtitle="Applied across the public API, customer app and emails">
      {!b ? <div className="grid place-items-center py-20"><Icon name="Loader2" className="h-7 w-7 animate-spin text-primary" /></div> : (
        <div className="space-y-6" data-testid="admin-branding">
          {!isOwner && <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 text-amber-600 px-4 py-3 text-sm">Only the Owner can edit branding.</div>}
          <div className="rounded-2xl border border-border bg-card p-5 grid sm:grid-cols-2 gap-3">
            {TEXT_FIELDS.map(([k, label]) => (
              <div key={k}><label className="text-xs font-semibold text-muted-foreground">{label}</label>
                <input data-testid={`brand-${k}`} disabled={!isOwner} value={b[k] || ""} onChange={(e) => set(k, e.target.value)} className="inp" /></div>
            ))}
            <div><label className="text-xs font-semibold text-muted-foreground">Primary color</label>
              <input data-testid="brand-primary" type="color" disabled={!isOwner} value={b.primary_color || "#6366F1"} onChange={(e) => set("primary_color", e.target.value)} className="mt-1 h-10 w-full rounded-lg border border-input bg-background" /></div>
            <div><label className="text-xs font-semibold text-muted-foreground">Button color</label>
              <input type="color" disabled={!isOwner} value={b.button_color || "#6366F1"} onChange={(e) => set("button_color", e.target.value)} className="mt-1 h-10 w-full rounded-lg border border-input bg-background" /></div>
          </div>
          <div className="rounded-2xl border border-border bg-card p-5 grid sm:grid-cols-2 gap-3">
            <div className="sm:col-span-2 text-sm font-bold">Asset URLs (upload in Media, paste the URL here)</div>
            {URL_FIELDS.map(([k, label]) => (
              <div key={k}><label className="text-xs font-semibold text-muted-foreground">{label}</label>
                <input data-testid={`brand-${k}`} disabled={!isOwner} value={b[k] || ""} onChange={(e) => set(k, e.target.value)} placeholder="https://..." className="inp" />
                {b[k] && <img src={b[k]} alt="" className="mt-2 h-10 w-auto rounded bg-muted p-1 object-contain" />}</div>
            ))}
          </div>
          {isOwner && <button data-testid="save-branding" onClick={save} disabled={busy} className="rounded-xl bg-primary text-primary-foreground px-5 py-2.5 text-sm font-bold hover:opacity-90 disabled:opacity-60">{busy ? "Saving..." : "Save & publish"}</button>}
        </div>
      )}
    </AdminLayout>
  );
}
